import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import config from "../config.json";
import { ContentTop } from "common/src/component/ContentTop";
import {
  AccountContainer,
  AccountDescription,
  CashbackHeader,
  PageContent,
  PageContentWrapper,
} from "common/src/styledComponents/AccountPage";
import { isMobileOnly } from "react-device-detect";

const Payments = ({ pageWidth, pages, titles, serverSetup }) => {
  const { t } = useTranslation();

  useEffect(() => {
    // console.log(titles)
    document.title = titles["Payments"];
  }, [titles]);

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };
    scrollToTop();
  }, []);

  return (
    <>
      <ContentTop showProfileMenu={false} skin={config.skin} pages={pages} />
      <PageContent>
        <PageContentWrapper>
          <AccountContainer>
            <CashbackHeader>{t("label_payments_header")}</CashbackHeader>
            <AccountDescription
              spanSize
              dangerouslySetInnerHTML={{ __html: t("text_payments") }}
            ></AccountDescription>
          </AccountContainer>
        </PageContentWrapper>
      </PageContent>
    </>
  );
};
export default Payments;
